import { Component, Inject, OnInit } from '@angular/core';
//import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { ComponentFlaggedVM } from '../../interpretation/models/interpretation.model';
import { UCInspectionsService } from '../uc-inspections.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-view-mbl-flagged-component-info',
  templateUrl: './view-mbl-flagged-component-info.component.html',
  styleUrls: ['./view-mbl-flagged-component-info.component.scss']
})
export class ViewMblFlaggedComponentInfoComponent implements OnInit {

  componentTypeId: number;
  ComponentId: number;
  FlaggedInfo: ComponentFlaggedVM;

  constructor(public dialogRef: MatDialogRef<ViewMblFlaggedComponentInfoComponent>,
    @Inject(MAT_DIALOG_DATA) private _data: any, private _inspectionsService: UCInspectionsService) { }

  ngOnInit() {
    this.componentTypeId = this._data.componentTypeId
    this.ComponentId = this._data.ComponentId;
    this._inspectionsService.getMblFlaggedComponentDetail(this._data.unSyncedInspectionId, this._data.MblInspectionDetailId, this.ComponentId).subscribe(r => {
      if (r) {
        this.FlaggedInfo = r;
      }
    });
  }
  onNoClick(){
    this.dialogRef.close(false);
  }

}
